import React from 'react';
import { Skeleton } from '@heroui/react';
import { Widget } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils';

type ProductDetailSkeletonProps = {
    'data-testid': string;
    id: string;
};

/**
 * Placeholder mirroring the detail page's header row (name, type chip, Edit
 * action), summary card, and a couple of collapsed variant rows so the layout
 * doesn't shift on load.
 */
export const ProductDetailSkeleton: React.FC<ProductDetailSkeletonProps> = ({
    'data-testid': dataTestId,
    id,
}) => (
    <div
        aria-busy
        className="flex flex-col gap-6"
        {...getNodeTestIdProp(dataTestId)}
        id={id}
    >
        <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-64 rounded-lg" />
            <Skeleton className="h-5 w-16 rounded-md" />
            <Skeleton className="ml-auto h-10 w-24 rounded-full" />
        </div>
        <Widget className="flex flex-col gap-4 p-5">
            <div className="grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-3">
                {Array.from({ length: 6 }).map((_, index) => (
                    <div
                        className="flex flex-col gap-2"
                        key={`${id}-field-${index}`}
                    >
                        <Skeleton className="h-3 w-16 rounded-md" />
                        <Skeleton className="h-4 w-24 rounded-md" />
                    </div>
                ))}
            </div>
        </Widget>
        <div className="flex flex-col gap-3">
            <Skeleton className="h-4 w-28 rounded-md" />
            {Array.from({ length: 3 }).map((_, index) => (
                <Skeleton
                    className="h-12 w-full rounded-xl"
                    key={`${id}-variant-${index}`}
                />
            ))}
        </div>
    </div>
);
